import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {CVA} from "./cva";
import {UIFormEngineComponentMetadata} from "./form";


@Component({
    selector: 'ui-input-checkboxes',
    template: `
	    <div class="ui-input-presentation" *ngIf="presentationMode">
		    {{presentationModeValue}}
	    </div>

	    <ng-container *ngIf="!presentationMode">
		    <div class=" form-control" style="    height: auto;">
			    <div *ngFor="let kv of metadata.options.choices|kv" class="form-check-inline">
				    <label class="form-check-label">
					    <input type="checkbox" class="form-check-input" name="{{name}}[kv.key]"
						   [value]="kv.key"
						   [checked]="cva.value.indexOf(kv.key)!=-1"
						   (change)="onModelChange(kv.key,$event.target['checked'])"/>
					    <span class="ui-input-choices-label">{{kv.value}}</span>
				    </label>
			    </div>
		    </div>
	    </ng-container>
    `,
    host: {class: 'ui-input-checkboxes'},
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UIInputCheckboxesComponent),
            multi: true
        }
    ]
})
export class UIInputCheckboxesComponent extends CVA {
    @Input() metadata: UIFormEngineComponentMetadata;
    @Input() name;
    @Input() presentationMode = false;
    public presentationModeValue = '';

    writeValue(obj: any) {
        // require obj to be an array! if not then we initialize it
        let wasNotAnArray = false;
        if (!Array.isArray(obj)) {
            obj = [];
            wasNotAnArray = true;
        }

        this.cva.value = obj;
        if (!wasNotAnArray) {
            this.cva.onChangeFunction(obj);
            this.cva.onTouchedFunction(obj);
        }
        this.calculatePresentationText();
    }

    public onModelChange(val, checked) {
        let found = this.cva.value.indexOf(val);

        if (!checked) {
            if (found != -1) {
                this.cva.value.splice(found, 1);
            }
        } else {
            if (found == -1) {
                this.cva.value.push(val);
            }
        }
        this.cva.onChangeFunction(this.cva.value);
        this.cva.onTouchedFunction(this.cva.value);

        this.calculatePresentationText();
    }

    calculatePresentationText() {
        const presentationModeValues = [];
        for (let v of this.cva.value) {
            presentationModeValues.push(this.metadata.options.choices[v]);
        }
        this.presentationModeValue = presentationModeValues.join(',');
    }

}
